import React from 'react';
import styled from 'styled-components';

import LocationInputContainer from 'containers/LocationInputContainer';

import Field from './Field';

const StyledLocationInputContainer = styled(LocationInputContainer)`
  height: 45px;
`;

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const LocationField = ({
  name,
  label,
  description,
  disabled,
  includeCity,
  includeFull,
  handlePlaceDetails,
  showClearButton,
  placeholder,
  onChange,
  onClear,
  onBlur,
  customErrorMatch,
  customError,
  success,
  locationText,
  addressTypes,
  componentRestrictions,
  ...props
}: {
  name: string;
  label?: string;
  description?: string;
  disabled?: boolean;
  includeCity?: boolean;
  includeFull?: boolean;
  handlePlaceDetails?: (arg0: Place) => void;
  showClearButton?: boolean;
  placeholder?: string;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange?: (...args: Array<any>) => any;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClear?: (...args: Array<any>) => any;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onBlur?: (...args: Array<any>) => any;
  'data-qa-id'?: string;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  customErrorMatch?: (arg0: APIErrors) => Record<string, any>;
  customError?: string | null | undefined;
  success?: boolean;
  onUpdateValue?: (arg0: string) => void;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onAutoCompleteSuggestionSelected?: (arg0: Record<string, any>) => void;
  componentRestrictions?: Record<string, string | Array<string>>;
  addressTypes?: Array<string>;
  locationText?: string | null | undefined;
}) => (
  <Field
    customErrorMatch={customErrorMatch}
    name={name}
    customError={customError}
    success={success}
    label={label}
    description={description}
    renderInput={({
      fieldQaIdPrefix,
      value,
      id,
      qaId,
      hasError,
      hasSuccess,
      updateValue,
    }) => {
      if (value && typeof value === 'object') {
        if (value.text) {
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line no-param-reassign
          locationText = value.text;
        }

        // @TODO: possible to use just `full` or `text` on the client?
        if (value.full && includeFull) {
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line no-param-reassign
          locationText = value.full;
        }
      }

      return (
        <StyledLocationInputContainer
          id={id}
          name={name}
          locationText={locationText}
          data-qa-id={
            props['data-qa-id']
              ? `${fieldQaIdPrefix}-${props['data-qa-id']}`
              : qaId
          }
          onChange={(location) => {
            updateValue(location);

            if (onChange) {
              onChange(location);
            }
          }}
          // @ts-expect-error fix type
          onAutoCompleteSuggestionSelected={
            props.onAutoCompleteSuggestionSelected
          }
          handlePlaceDetails={handlePlaceDetails}
          hasError={hasError}
          hasSuccess={hasSuccess}
          onBlur={onBlur}
          onClear={onClear}
          disabled={disabled}
          showClearButton={showClearButton}
          includeCity={includeCity}
          includeFull={includeFull}
          placeholder={placeholder}
          updateValue={updateValue}
          addressTypes={addressTypes}
          componentRestrictions={componentRestrictions}
        />
      );
    }}
  />
);

export default LocationField;
